export default "__VITE_ASSET__DU6IO_Fb__"